<template>
  <div class="pl-5 pr-5 mt-5">
    <div class="title">
      <v-icon class="indent pr-1">mdi-square-medium</v-icon>
      <span class="">{{ title }}</span>
    </div>

    <div class="font-weight-light mt-3">
      <p>
        Webová aplikace pro správu speciálních linuxových serverů instalovaných zákazníkům.
        Aplikace je určena technikům. Umožňuje zobrazení informací o systému, nastavení základních
        funkcí serveru, instalaci balíků, instalaci a konfiguraci aplikačních a databázových serverů
        a databází, správu uživatelů, skupin a oprávnění, správu záloh atd. Aplikace funguje na bázi
        klient-server, s klienty komunikuje pomocí HTTP a TCP WebSocket komunikačního protokolu.
        Klientská část je řešena jako multi-window aplikace.
      </p>
      <p>
        Každá na klientovi spuštěná akce je na serveru vedena jako samostatný proces běžící na pozadí,
        takže je možno se z klienta odhlásit. Po přihlášení je pak možno si procesy nechat zobrazit
        a dále řídit jejich průběh, to vše na stránce pro kontrolu procesů. Vše je pochopitelně zajištěno
        oprávněními podle přihlášeného uživatele a skupiny, do které uživatel patří.
      </p>

      <div class="subtitle-1">
        <span>Použité technologie:</span>
      </div>

      <ul class="mt-3">
        <li>PHP</li>
        <li>Python</li>
        <li>TCP, UDP a WebSocket komunikace</li>
        <li>HTML</li>
        <li>jQuery</li>
        <li>AJAX</li>
      </ul>

    </div>

    <ImgCarousel :items="images" @click="click"></ImgCarousel>

  </div>
</template>

<script>
  import { call } from 'vuex-pathify';

  import ImgCarousel from "@/components/ImgCarousel";

  export default {
    name: "AdminConsole",
    components: {
      ImgCarousel
    },
    data () {
      return {
        title: 'Administrační konzole pro správu klientských serverů',
        images: [
          {
            src: '/img/refs/admincon/01.png',
            description: 'Upload souborů',
            alt: ''
          },
          {
            src: '/img/refs/admincon/02.png',
            description: 'Ukázka multi-window řešení',
            alt: ''
          },
          {
            src: '/img/refs/admincon/03.png',
            description: 'Přihlášení sezení',
            alt: ''
          },
          {
            src: '/img/refs/admincon/04.png',
            description: 'Výběr požadované funkce v systému',
            alt: ''
          },
          {
            src: '/img/refs/admincon/05.png',
            description: 'Výběr požadované funkce síťových zařízení',
            alt: ''
          },
          {
            src: '/img/refs/admincon/06.png',
            description: 'Nastavení opravnění',
            alt: ''
          },
          {
            src: '/img/refs/admincon/07.png',
            description: 'Výpis běžících procesů na serveru',
            alt: ''
          },
          {
            src: '/img/refs/admincon/08.png',
            description: 'Výpis nastavní síťových rozhraní na serveru',
            alt: ''
          },
          {
            src: '/img/refs/admincon/09.png',
            description: 'Založení nové databáze',
            alt: ''
          },
        ]
      }
    },
    methods: {
      ...call('imgGallery', ['setItems', 'showGallery']),
      click (item) {
        this.showGallery({
          items: this.images,
          index: item.index,
          title: this.title
        });
      }
    }
  }
</script>

<style scoped>
  .indent {
    margin-left: -7px;
    margin-top: -2px;
  }
</style>
